import { SxProps } from '@mui/material';
import { width } from '@mui/system';
import { black1, grey, yellow1 } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');

export const paperProps: SxProps = { borderRadius: '8px', padding: '32px 36px', width: '400px',pr: '0px' };

export const inputHeader: SxProps = {
  fontSize: '15px',
  height: '19px',
};

export const dialogTitle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: '28px',
  padding: '0px',
  paddingBottom: '0px',
};


export const closeBtn: SxProps = {
  position: 'absolute',
  top: '32px',
  right: '32px',
  padding: '10px',
  minWidth: '36px',
  height: '36px',
  width: '36px',
  borderRadius: '8px',
  alignItems: 'centre',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};

export const dialogContent: SxProps = {
  display: 'flex',
  padding: 0,
  paddingRight: '20px',
  flexDirection: 'column',
  gap: '20px',
  overflowY: 'auto',
  overflowX: 'clip',
  // [theme.breakpoints.down(1920)]: {
  //   paddingTop: '6px',
  // },
};


// export const dialogContent: SxProps = {
//   display: 'flex',
//   padding: '42px',
//   flexDirection: 'column',
//   gap: '20px',
//   overflow: 'auto',
// };

export const dialogContentBoxes: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '320px'
};

export const datePickerBox: SxProps = {
  display: 'flex',
  gap: '16px',
  width: '320px'
};

export const inputOutlined: SxProps = {
  fontSize: '16px',
  fontWeight: 400,
  height: '48px',
  paddingLeft: '16px',
  borderWidth: '1px',
  borderRadius: '8px',
  lineHeight: 1,
  '& .MuiInputBase-input::placeholder': {
    fontSize: '16px',
    fontWeight: '400px',
    color: 'rgba(20, 25, 31, 0.4)',
  },

  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: grey,
    borderWidth: '0.5px',
  },
};

export const selectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    height: '46px',
    borderWidth: '1px',
    borderStyle: ' solid',
    borderColor: state.isFocused ? grey : ' rgba(20, 25, 31, 0.10)',
    borderRadius: '8px',
    // borderColor: state.isFocused && 'red',
    boxShadow: state.isFocused ? null : null,
    '&:hover': {
      cursor: 'pointer',
      borderColor: grey,
    },
  }),

  container: (base: any) => ({
    ...base,
    width: '320px',
  }),
  menu: (base: any, state: any) => ({
    ...base,
    minWidth: '300px',
    borderRadius: '8px',
    position: 'absolute',
    marginTop: 0,
    padding: 0,
    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  }),
  menuList: (base: any) => ({
    ...base,

    padding: '16px 0',
    fontFamily: 'Yelo',
  }),
  placeholder: (base: any) => ({
    ...base,
    paddingLeft: '16px',
    fontWeight: '400',
    fontSize: '16px',
    fontFamily: 'Yelo',
    color: 'rgba(20, 25, 31, 0.40)',
    marginLeft: 0,
    marginRight: 0,
  }),

  valueContainer: (base: any, state: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    background: 'transparent',
    fontWeight: 500,
  }),

  singleValue: (base: any) => ({
    ...base,
    margin: 0,
    padding: '12px 16px',
    fontFamily: 'Yelo',
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    width: 0,
    height: 0,
  }),

  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    padding: 0,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),

  option: (base: any, state: any) => ({
    ...base,
    color: black1,
    background: state.isSelected ? '#F3F4F6!important' : 'transparent',
    paddingLeft: '19px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    '&:hover': { background: '#F3F4F6!important', cursor: 'pointer' },
  }),

  menuPortal: (base: any) => ({ ...base, zIndex: '1000000' }),

  indicatorsContainer: (base: any) => ({ ...base, paddingRight: '8px' }),
};

export const btnsBox: SxProps = {
  display: 'flex',
  gap: '12px',
  justifyContent: 'space-between',
  padding: 0,
  flexDirection: 'column',
};

export const smallScreenBtnBox: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
};

export const notif: SxProps = {
  background: yellow1,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  width: '20px',
  height: '20px',
};

export const notifText: SxProps = {
  fontSize: '12px',
  fontWeight: '700',
  fontFamily: 'Yelo',
};

export const dialogAction: SxProps = {
  padding: '32px 40px 0px 0px',
};

export const btnFilter = (bg: boolean) => {
  return {
    width: 'fit-content',
    height: '48px',
    display: 'flex',
    gap: '10px',
    minWidth: '48px',
    p: '12px',

    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px',
    },
  };
};
